module.exports = __webpack_public_path__ + "img/block_2.195cdcff.webp";